import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white' | 'dark';
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  fullWidth = false,
  className = '',
  ...props 
}) => {
  const baseStyles = "font-extrabold py-4 px-8 rounded-2xl transition-all duration-500 ease-apple transform hover:-translate-y-1 active:scale-95 shadow-md text-base tracking-tight flex items-center justify-center gap-2 uppercase";
  
  const variants = {
    primary: "bg-brand-orange text-white hover:bg-orange-600 hover:shadow-orange-500/40 hover:shadow-2xl border-2 border-transparent",
    secondary: "bg-white text-brand-dark border-2 border-brand-orange hover:bg-orange-50 hover:shadow-lg",
    outline: "bg-transparent border-2 border-brand-dark text-brand-dark hover:bg-brand-dark hover:text-white hover:shadow-xl",
    white: "bg-white text-brand-orange hover:bg-gray-50 shadow-lg hover:shadow-xl",
    dark: "bg-brand-dark text-white hover:bg-black border-2 border-transparent hover:shadow-2xl hover:shadow-black/20"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};